/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorBanner from 'base/components/labrador/Banner';

export const DynamicLabradorBanner: typeof LabradorBanner = (props) => {
    return <ErrorBoundary><LabradorBanner {...props} /></ErrorBoundary>;
}
export type DynamicLabradorBannerProps = PropsFromComponent<typeof LabradorBanner>;
